import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApiService from './services/api.service'
import { TokenService }  from './services/storage.service'
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)

ApiService.init('https://membresias-api.fundacionhtn.org/api/')
ApiService.mount401Interceptor();

if (TokenService.getToken()) {
  ApiService.setHeader()
}

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
